export default "__VITE_ASSET__CSYLOCX1__"